import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  Switch,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { ModalType } from 'constants/common';
import { CookieStorage } from 'utils/cookie-storage';
import SizeTable from './components/Table';
import CreateBotTeleModal from './components/CreateBotTeleModal';
import Pagination from 'components/Pagination/Pagination';
import { useQueryGetBotTeleList } from 'services/bottelegram';
import { useQueryGetListBranding } from 'services/branding';
import { mappingOptionSelect } from 'utils/mapping';
import { Select } from 'chakra-react-select';


const BotTeleManager = () => {
  const textColor = useColorModeValue('gray.700', 'white');
  const history = useHistory();
  const [botEditing, setBotEditing] = useState(null);
  const [searchTitle, setSearchTitle] = useState('');
  const [searchType, setSearchType] = useState(false);
  const [searchBrand , setSearchBrand] = useState('');
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    if (!CookieStorage.isAuthenticated()) {
      return history.push('/auth/sign-in');
    }
  }, []);

  const { isOpen: isCreateModalOpen, onOpen: onOpenCreateModal, onClose: onCloseCreateModal } = useDisclosure();
  const { isOpen: isChangeStatusModalOpen, onOpen: onOpenChangeStatusModal, onClose: onCloseChangeStatusModal } = useDisclosure();
  const openModal = useMemo(
    () => ({
      [ModalType.Add]: onOpenCreateModal,
      [ModalType.ChangeStatus]: onOpenChangeStatusModal,
    }),
    [onOpenCreateModal, onOpenChangeStatusModal]
  );
  const closeModal = useMemo(
    () => ({
      [ModalType.Add]: onCloseCreateModal,
      [ModalType.ChangeStatus]: onCloseChangeStatusModal,
    }),
    [onCloseCreateModal, onCloseChangeStatusModal]
  );

  const { data: botTeleTable, refetch } = useQueryGetBotTeleList(
    {
      ...filter,  
    },
    { enabled: CookieStorage.isAuthenticated() }
  );

  const { data: brandData } = useQueryGetListBranding(
    {},
    { enabled: CookieStorage.isAuthenticated() }
  );

  const handleUpdateItem = (size, modalType) => {
    openModal?.[modalType]?.();
    setBotEditing(size);
  };

  const handelCloseModal = modalType => {
    closeModal?.[modalType]?.();
    setBotEditing(null);
  };

  const handleSearchBranding = () => {
    setFilter({
      ...filter,
      searchKeyword: searchTitle,
      brandingId : searchBrand?.value,
      isActive: searchType
    });
  };

  const handleReset = () => {
    setFilter({
      pageIndex: 0,
      pageSize: 10,
    });
    setSearchTitle('');
    setSearchBrand('');
   
  };

  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px', lg: '100px' }}>
      <Card p="16px" mb="24px" bg="#fff">
        <CardHeader p="12px 5px" mb="12px">
          <Flex justifyContent={'space-between'}>
            <Flex direction={'column'}>
              <Flex direction="column" gap={'30px'}>
                <Text fontSize="xl" color={textColor} fontWeight="bold">
                  Danh sách Bot Telegram
                </Text>
              </Flex>
              <Flex justifyContent={'space-between'} alignItems={'end'} gap={'20px'} mt={'20px'}>
                <Stack>
                  <Flex alignItems={'center'} gap={'20px'} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                    <FormControl minWidth={{ base: 'full', sm: '250px' }}>
                      <FormLabel>Tìm kiếm</FormLabel>
                      <Input value={searchTitle} onChange={e => setSearchTitle(e.target.value)} />
                    </FormControl>
                    <FormControl minWidth={{ base: 'full', sm: '100px' }}>
                      <FormLabel>Chọn Brand</FormLabel>
                      <Select
                        isClearable
                        placeholder="Chọn Brand"
                        value={searchBrand}
                        onChange={event => setSearchBrand(event)}
                        options={mappingOptionSelect(brandData?.data, 'name','_id')}
                      >
                      </Select>
                    </FormControl>
                    <FormControl minWidth={{ base: 'full', sm: '100px' }}>
                      <FormLabel>Chọn trạng thái</FormLabel>  
                      <Select
                        isClearable
                        placeholder="Chọn trạng thái"
                        value={searchType !== undefined ? { label: searchType ? 'Đang hoạt động' : 'Không hoạt động', value: searchType.toString() } : null}
                        onChange={e => setSearchType(e?.value === 'true' ? true : e?.value === 'false' ? false : undefined)}
                        options={[
                          { label: 'Đang hoạt động', value: 'true' },
                          { label: 'Không hoạt động', value: 'false' },
                        ]}
                      >
                      </Select>
                    </FormControl>
                    <Button maxH="40px" alignSelf={'end'} width={"100px"} onClick={handleReset}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer">
                        Tải lại
                      </Text>
                    </Button>
                    <Button variant="primary" maxH="50px" alignSelf={'end'} width={"150px"} onClick={handleSearchBranding}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer" >
                        Tìm kiếm
                      </Text>
                    </Button>
                  </Flex>
                </Stack>
              </Flex>
            </Flex>
            <Flex alignItems={'start'} gap={4}>
              <Button bg="#3182ce" color="#fff" _hover={{ bg: '#67a1d7' }} onClick={onOpenCreateModal}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Tạo Bot Telegram
                </Text>
              </Button>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody overflowX="auto">
          <Stack overflow={'auto'}>
            <SizeTable botTeleTable={botTeleTable?.data || [] } handleUpdateBotTele={handleUpdateItem} refetch={refetch} />
          </Stack>
          <Flex justifyContent={'flex-end'}>
            <Pagination
              page={botTeleTable?.pagination?.page}
              pageLength={botTeleTable?.pagination?.pageSize}
              totalRecords={botTeleTable?.pagination?.count}
              onPageChange={(page, pageLength) => {
                setFilter({
                  ...filter,
                  pageSize: pageLength,
                  pageIndex: page - 1,
                });
              }}
            />
          </Flex>
        </CardBody>
      </Card>
      {isCreateModalOpen && (
        <CreateBotTeleModal botTeleDetail={botEditing} isOpen={isCreateModalOpen} onClose={handelCloseModal} refetch={refetch} optionData={brandData || []} />
      )}
    </Flex>
  );
};

export default BotTeleManager;
